import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadscrumbComponent } from './breadscrumb.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [BreadscrumbComponent],
    imports: [
        CommonModule,
        MatMenuModule,
        MatIconModule,
        MatTooltipModule,
        SharedModule,
    ],
    exports: [BreadscrumbComponent],
})
export class BreadscrumbModule {}
